import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ResolveEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

/* eslint-disable @angular-eslint/directive-selector */
// Increasing integer for auto generating the order 
let nextOrder = 0;

@Directive({
	selector: '[cwpComponent]'
})
/**
 * This directive is used to populate the component with the id and order provided by the ActivatedRoute snapshot within the html tag on which this directive is applied.
 * The component should be there in the same teamsite page where the app package is placed. Currently the component is hidden by free form.
 * TODO: In future we will work to provide a option to hide and show within CWP components. So we can eliminate free form.
 * For Example:
 * <div cwpComponent></div>
 * No order is passed so the directive will auto generate the order i.e 1 in this case.
 * Then it will find the component with this order from the ActivatedRoute snapshot data.
 * Then using query selector will extract the innerHtml of the component from DOM.
 * If componentData is available then assign it to element's innerHtml on directive is applied.
 * Else log error  No component found with order on this route. Please check the config or set the correct order.
 */
export class CwpComponentDirective implements OnInit {
	@Input() public order: number = ++nextOrder;

	constructor(private element: ElementRef, private router: Router, private route: ActivatedRoute) { }

	public ngOnInit(): void {
		this.populateComponent();
		if (+this.order === 1) {
			this.resetOrderOnNavigate();
		}
	}

	private populateComponent(): void {
		const routeData = this.route.snapshot.data['cwpComponents'];
		const componentDetail = routeData?.components?.find((component: {
			id: string | number;
			order: number;
		}) => +component.order === +this.order);
		if (componentDetail) {
			const componentData = document.querySelector(`[id="${componentDetail.id}"]`)?.innerHTML;
			if (componentData) {
				this.element.nativeElement.innerHTML = componentData;
			} else {
				console.error(`No component found with order '${this.order}' on this route. Please check the config or set the correct order.`);
			}
		}

	}

	private resetOrderOnNavigate(): void {
		this.router.events
			.pipe(
				filter((event): event is ResolveEnd => event instanceof ResolveEnd),
				take(1)
			)
			.subscribe(() => {
				nextOrder = 0;
			});
	}
}
